import React, { useState, useEffect } from 'react';

export const OfflineBanner: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        setShowReconnected(true);
        // Hide reconnected message after 3 seconds
        setTimeout(() => {
          setShowReconnected(false);
          setWasOffline(false);
        }, 3000);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      setShowReconnected(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  // Don't show anything if online and never been offline
  if (isOnline && !showReconnected) {
    return null;
  }

  return (
    <>
      {/* Offline Banner */}
      {!isOnline && (
        <div className="fixed top-16 left-0 right-0 z-50 bg-orange-500 text-white px-4 py-3 shadow-lg">
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
            <span className="material-symbols-outlined animate-pulse">
              wifi_off
            </span>
            <p className="text-sm sm:text-base font-medium">
              No internet connection. Some features may not be available.
            </p>
          </div>
        </div>
      )}

      {/* Reconnected Banner */}
      {showReconnected && (
        <div className="fixed top-16 left-0 right-0 z-50 bg-green-500 text-white px-4 py-3 shadow-lg animate-slide-down">
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
            <span className="material-symbols-outlined">
              check_circle
            </span>
            <p className="text-sm sm:text-base font-medium">
              Back online! Your connection has been restored.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

